import React from "react";
import { Box, Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function ThankYouSelfDiscoveryPage() {
  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: { xs: 3, md: 6 } }}>
      <Typography variant="h3" align="center" color="text.primary" sx={{ mb: { xs: 2, md: 3 }, fontWeight: 700 }}>
        Thank you — your Self‑Discovery Journal is on its way
      </Typography>
      <Box sx={{ mx: 'auto', width: { xs: '90%', md: '60%' }, borderBottom: '1px solid', borderColor: 'divider', mb: { xs: 2, md: 4 } }} />

      <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, bgcolor: 'custom.beige' }}>
        <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
          We’ve received your request. We’ll email the Self‑Discovery Journal shortly. The three psychological tests will be sent later in a separate email. Please follow the instructions in that email to complete them.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" color="text.primary" gutterBottom>
          What happens next
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><EmailIcon color="primary" /></ListItemIcon>
            <ListItemText primary="Journal Delivery" secondary="You’ll receive the journal by email soon." />
          </ListItem>
          <ListItem>
            <ListItemIcon><AccessTimeIcon color="primary" /></ListItemIcon>
            <ListItemText primary="Tests Sent Separately" secondary="We’ll send the 3 tests in a later email with clear instructions." />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
            <ListItemText primary="Complete & Return" secondary="Finish the tests and email your answers to hello@sarasjournal.com." />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
            <ListItemText primary="Personalized Results" secondary="We’ll analyze your data and send your report and recommendations." />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
}
